module.exports = __webpack_public_path__ + "static/media/neutral.a5372a15.svg";